import React, { useState, useEffect } from "react";
import TableBody from "./TableBody";
import TableHead from "./TableHead";

export const OrderTable = ({
  clase,
  columns,
  data,
  actions = [],
  renderActionItems,
  onSort = () => {},
  sortColumn = ""
}) => {
  
  const handleSorting = (sortField, sortOrder) => {
    if (sortField) {
      
      onSort(`${sortField}:${sortOrder}`);
    }
  };
  
  return (
    <table className={clase} >
      <TableHead {...{ columns, handleSorting, sortColumn }} />
      <TableBody
        actions={actions}
        {...{ columns, tableData : data }}
        renderActionItems={renderActionItems}
      />
    </table>
  );
};
